export default __webpack_public_path__ + "static/media/l5-p3.7524472e.svg";